import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {
  AfterSalesRoutes,
} from "../../../routes";

export function AfterSalesLayout() {
  return <SwitchRoute routes={AfterSalesRoutes} />;
}
